import React from "react";
import PropTypes from "prop-types";
import classes from "./MobileHeader.module.css";
import { logoColor } from "../../constant/imagePath";
import Fonts from "../assets/Fonts";
import { NameAvatar } from "../NameAvatar/NameAvatar";
import { ReactSVG } from "react-svg";

export const MobileHeader = ({
  userData,
  isLogo,
  logo,
  isAvatar,
  customStyle,
  avatarStyle,
}) => {
  return (
    <div className={classes.header} style={{ ...customStyle }}>
      {isLogo && (
        <ReactSVG
          src={logo !== undefined ? logo : logoColor}
          beforeInjection={(svg) => {
            svg.classList.add(classes.logoBox);
          }}
        />
      )}
      {isAvatar && (
        <div className={classes.avatar}>
          <NameAvatar
            userName={userData?.displayName}
            customStyle={{ ...Fonts.p4, ...avatarStyle }}
          />
        </div>
      )}
    </div>
  );
};

MobileHeader.propTypes = {
  userData: PropTypes.object,
  customStyle: PropTypes.object,
  avatarStyle: PropTypes.object,
  isLogo: PropTypes.bool,
  isAvatar: PropTypes.bool,
};

MobileHeader.defaulProps = {
  userData: {
    displayName: "H M",
  },
  isLogo: true,
  logo: logoColor,
};
